
import React, { Component } from 'react'

export default class Button extends Component {

  render() {
    const { buttonName, onClick, buttonType, disabled = false, history, title } = this.props;
    var button = undefined;
    switch (buttonType) {
      case 'save':
        button = <button type="button" disabled={disabled} onClick={(e) => onClick(e)} className="primary  m-1">{buttonName} </button>
        break;
      case 'cancel':
        button = <button type="button" onClick={() => history.goBack()} className="primary m-1">{"back"} </button>
        break;
      case 'add':
        button = <a
          style={{ display: "block" }}
          className="btn-floating btn-small waves-effect waves-light green pull-right my-1 mr-1"
          onClick={(e) => onClick(e)}
        >
          <i className="material-icons">add</i>
        </a>
        break;
      case 'remove':
        button = <a
          style={{ display: "block" }}
          class="btn-floating btn-small waves-effect waves-light red pull-right my-1 mr-1"
          id="del-sample-size-btn pull-rog pull-right"
          onClick={onClick}
        >
          <i class="material-icons">clear</i>
        </a>
        break;
      default:
        button = <button type="button" disabled={disabled} onClick={(e) => onClick(e)} className="primary  m-1" title={title}>{buttonName} </button>
    }
    return (
      button
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Buttons/Button.js